import { render, staticRenderFns } from "./VillageDetail.vue?vue&type=template&id=0aafe944"
import script from "./VillageDetail.vue?vue&type=script&lang=js"
export * from "./VillageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports